import { render, staticRenderFns } from "./TabAdmins.vue?vue&type=template&id=10780336"
import script from "./TabAdmins.vue?vue&type=script&lang=js"
export * from "./TabAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports